<template>
  <v-card>
    <v-form ref="validateForm" autocomplete="off" @submit="$event.preventDefault()">
      <v-card-title primary-title class="pa-3" v-if="references.title">
        <template v-if="references.showActionsOnHeader">
          <h5> {{ references.title }} </h5>
          <v-spacer></v-spacer>
          <v-card-actions v-if="references.buttons">
            <slot name="createorder"></slot>
            <v-spacer></v-spacer>
            <template v-for="(button, index) in references.buttons">
              <v-spacer v-if="button.isEnd && index === (references.buttons.length - 1)" :key="`${index}_space`"></v-spacer>
              <v-btn :key="index" :loading="button.loading" :id="references.automationModuleName ? `${references.automationModuleName}_heading_${button.name}_btn` : `heading_${button.name}_btn`"
                 v-if="button.is_show" @click="button.click" :color="button.color"
                :disabled="button.disabled"> {{ button.label }} </v-btn>
            </template>
            <slot name="share_report"></slot>
            <slot name="download_report"></slot>
            <v-spacer v-if="!references.isHideSpacer"></v-spacer>
          </v-card-actions>
        </template>
        <template v-else>
          <v-row class="ma-0">
            <v-col cols="6" class="pa-0">
              <h5> {{ references.title }} </h5>
            </v-col>
            <v-col cols="6" class="pa-0 text-right">
              <slot name="title-actions"></slot>
            </v-col>
          </v-row>
        </template>
      </v-card-title>
      <v-divider v-if="references.title"></v-divider>
      <slot name="information"></slot>
      <v-container fluid grid-list-xl>
        <v-layout wrap class="pa-0 pt-3 pl-3 pr-3">
          <slot name="salesproduct"></slot>
          <template v-for="(prop, index) in references.properties">
            <template v-if="prop.is_visible !== undefined ? prop.is_visible : true">
              <v-flex :class="prop.class" :key="index" :style="prop.style">
                <slot name="custom_fields" v-if="prop.model === 'custom_fields'"></slot>
                <slot name="related_records" v-if="prop.model === 'related_records'"></slot>
                <template v-if="prop.type === FORM_TYPE.TEXT">
                  <v-text-field outlined :hide-details="!prop.hint" :hint="prop.hint" persistent-hint :loading="prop.loading"
                    :label="prop.label" dense :suffix="prop.suffix"
                    @click:append="prop.append_click ? prop.append_click(model.saleId ? model.saleId : '') : null"
                    @change="prop.change ? prop.change(): ''"
                    :readonly="prop.readonly"
                    :append-icon="prop.append_icon ? prop.append_icon : ''"
                    :id="prop.model" :ref="prop.ref" @input="prop.input" :placeholder="prop.placeholder"
                    :disabled="prop.disabled" :rules="prop.rules" v-model="model[prop.model]"> </v-text-field>
                </template>
                <template v-if="prop.type === FORM_TYPE.NUMBER">
                  <v-text-field outlined hide-details :type="FORM_TYPE.NUMBER" dense :id="prop.model" @change="prop.change ? prop.change(): ''" :label="prop.label" :readonly="prop.readonly" :rules="prop.rules" v-model="model[prop.model]" :disabled="prop.disabled"> </v-text-field>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.TEXTAREA">
                  <v-textarea outlined hide-details :label="prop.label" dense v-if="!prop.is_show" @change="prop.change ? prop.change(): ''" :id="prop.model" :rules="prop.rules" v-model="model[prop.model]" :disabled="prop.disabled" :rows="prop.rows"></v-textarea>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.CHECKBOX">
                  <v-checkbox class="ma-0 py-0" :label="prop.label" hide-details :id="prop.model" dense color="primary" :rules="prop.rules" v-model="model[prop.model]" @change="prop.click ? prop.click(prop.model): ''" :disabled="prop.disabled"> </v-checkbox>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.AUTO_COMPLETE">
                  <v-autocomplete outlined hide-details :items="prop.items" dense :id="prop.model" :disabled="prop.disabled"
                    :rules="prop.rules" :item-text="prop.select_text" :multiple="prop.multiple" autocomplete="off"
                    @click:append="prop.click(prop.term)"
                    @change="prop.change ? prop.change() : false"
                    @keyup="prop.keyup ? $event.keyCode !== 13 ? prop.keyup(prop.term, $event) : '' : false"
                    :item-value="prop.select_value" :label="prop.label"
                    :loading="prop.loading" :placeholder="prop.placeholder ? prop.placeholder : ''"
                    :ref="prop.term? '' + prop.term : ''"
                    :append-icon="prop.is_list ? 'add_circle' : prop.append_icon || ''"
                    @click:clear="$nextTick(() => model[prop.model] = null)"
                    :item-disabled="prop.item_disabled"
                    clearable
                    v-model="model[prop.model]">
                    <template v-slot:selection="{ item, index }" v-if="prop.multiple">
                      <span v-if="index === 0">{{ item[prop.select_text] }}</span>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >(+{{ model[prop.model].length - 1 }} {{ $t('message.common.others') }})</span>
                    </template>
                    <template v-slot:item="{ item }" v-if="prop.custom_item_slot">
                      <span :style="{ color: item.isactive ? 'inherit' : '#ec1b1b' }">
                        {{ typeof prop.select_text === 'function' ? prop.select_text(item) : item[prop.select_text] }}
                      </span>
                    </template>
                  </v-autocomplete>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.AUTO_COMPLETE_LIVE">
                  <v-autocomplete outlined hide-details :items="prop.items" :id="prop.model" :disabled="prop.disabled" dense
                    :rules="prop.rules" :item-text="prop.select_text" :multiple="prop.multiple" autocomplete="off"
                    :item-value="prop.select_value" :label="prop.label"
                    clearable
                    @change="prop.change ? prop.change() : ''"
                    v-model="model[prop.model]"
                    :search-input.sync="model[prop.live_search_model]"
                    :loading="prop.loading ? prop.loading : false"
                    :ref="prop.ref"
                    @keydown.native.enter.exact.prevent="references.enterAsTab ? handlerEnterPress($event, index, prop.ref) : ''"
                    >
                    <template v-slot:no-data v-if="!model[prop.live_search_model]">
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>{{ $t('message.common.startTyping') }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item, index }" v-if="prop.multiple">
                      <span v-if="index === 0">{{ item[prop.select_text] }}</span>
                      <span
                        v-if="index === 1"
                        class="grey--text caption"
                      >(+{{ model[prop.model].length - 1 }} {{ $t('message.common.others') }})</span>
                    </template>
                  </v-autocomplete>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.SELECT">
                  <v-select outlined hide-details :items="prop.items" @change="prop.change ? prop.change(): ''" dense :id="prop.model" :rules="prop.rules" :item-text="prop.select_text" :multiple="prop.multiple" :item-value="prop.select_value" :label="prop.label" :disabled="prop.disabled" v-model="model[prop.model]"></v-select>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.PASSWORD">
                  <v-text-field outlined hide-details :label="prop.label" dense :id="prop.model" :rules="prop.rules" :type="FORM_TYPE.PASSWORD" v-model="model[prop.model]"> </v-text-field>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.COMBOBOX" class="pt-2">
                  <slot name="combo" v-if="prop.iscustomer"></slot>
                  <div class="combo" v-else>
                    <v-combobox v-model="model[prop.model]" :items="prop.items" dense hide-details hide-selected :rules="prop.rules" :label="prop.label" multiple persistent-hint small-chips :id="prop.model" :disabled="prop.disabled" outlined></v-combobox>
                  </div>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.DATEPICKER">
                  <v-menu :close-on-content-click="false" v-model="model[prop.menu]" transition="scale-transition" offset-y min-width="290px" v-if="prop.is_show !== undefined ? prop.is_show : true">
                    <template v-slot:activator="{ on }">
                      <v-text-field outlined hide-details v-model="model[prop.model]" dense :rules="prop.rules" clearable :label="prop.label" prepend-icon="event"
                      readonly v-on="on" :disabled="prop.disabled" @click:clear="$nextTick(() => model[prop.picker] = null)"
                      @change="prop.change ? prop.change(): ''"></v-text-field>
                    </template>
                    <v-date-picker :color="prop.color" @input="model[prop.menu] = false" :min="prop.min" :max="model[prop.max]" v-model="model[prop.picker]"
                    :locale="$i18n.locale" first-day-of-week='1' :disabled="prop.disabled"></v-date-picker>
                  </v-menu>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.QUICKADD">
                  <v-btn fab small outline color="primary" :id="prop.type" @click="$router.push(prop.to)" :disabled="prop.disabled">
                    <v-icon color="primary">perm_identity</v-icon>
                  </v-btn>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.TIMEPICKER">
                  <v-menu :close-on-content-click="false" :ref="prop.menu" v-model="model[prop.menu]" transition="scale-transition" offset-y min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field outlined hide-details slot="activator" dense :label="prop.label" :rules="prop.rules" v-model="model[prop.model]" readonly v-on="on" prepend-icon="access_time" clearable :disabled="prop.disabled"
                      @change="prop.change ? prop.change(): ''"></v-text-field>
                    </template>
                    <v-time-picker color="primary" v-model="model[prop.model]" :min="model[prop.min]" :max="model[prop.max]" @click:minute="$refs[prop.menu][0].save(model[prop.model])" :allowed-minutes="allowedStep" format="24hr" :disabled="prop.disabled"></v-time-picker>
                  </v-menu>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.FILES && prop.is_show">
                  <v-file-input :accept="prop.accept" dense :disabled="prop.disabled" hide-details outlined v-model="model[prop.model]" :rules="prop.rules" :label="prop.label"
                    :multiple="prop.multiple" :value="prop.value ? prop.value : null" ref="fileinput"
                    @change="prop.change ? prop.change() : false"></v-file-input>
                  <slot :name="prop.slot"></slot>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.COLORPICKER">
                  <v-menu bottom :close-on-content-click="false" offset-y v-model="model[prop.menu]">
                    <template v-slot:activator="{ on }">
                      <v-text-field :label="prop.label" v-model="model[prop.model]" dense outlined hide-details class="ma-0 pa-0" readonly slot="activator" v-on="on" :disabled="prop.disabled"></v-text-field>
                    </template>
                    <v-color-picker v-if="[prop.menu]" v-model="model[prop.model]" bottom flat :disabled="prop.disabled" />
                  </v-menu>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.RADIO && prop.is_show">
                  <v-radio-group v-model="model[prop.model]" hide-details row class="ma-0" @change="prop.click ? prop.click(prop.model): ''">
                    <template v-for="items in prop.items">
                      <v-radio :label="items.text" :value="items.value" dense :key="items.value"></v-radio>
                    </template>
                  </v-radio-group>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.DIVIDER">
                  <v-subheader class="pl-0 font-weight-bold body-1">{{ prop.label }}:</v-subheader>
                  <v-divider></v-divider>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.LINK">
                  <router-link :to="prop.to" v-if="model[prop.model]">{{ model[prop.model] }}</router-link>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.LABEL">
                  <span>{{ prop.label }}</span>
                </template>
                <template v-else-if="prop.type === FORM_TYPE.SLOT && prop.is_show">
                  <slot :name="prop.slot"></slot>
                </template>
              </v-flex>
            </template>
          </template>
        </v-layout>
      </v-container>
      <v-card-text class="pa-0">
        <slot name="extraDetails"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions v-if="references.buttons">
        <v-spacer></v-spacer>
        <v-layout justify-center>
          <v-flex>
            <template v-for="(button, index) in references.buttons">
              <v-btn class="mx-1" :key="index" :loading="button.loading" :id="button.name" v-if="button.is_show" @click="button.click" :color="button.color" :disabled="button.disabled"
                :class="button.class || ''"> {{ button.label }} </v-btn>
              <v-spacer :key="`${index}_space`" v-if="button.space"></v-spacer>
            </template>
          </v-flex>
        </v-layout>
        <template v-for="(button, index) in references.end_buttons">
          <v-menu offset-y v-if="button.ismenu" :key="`${index}_menu`">
            <template v-slot:activator="{ on, attrs }">
              <v-btn :class="references.end_buttons.length - 1 === index ? 'mr-8' : ''" color="info" class="ml-3" v-on="on" dark v-bind="attrs">
                {{ button.label }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-for="(item, index) in button.items" @click="button.click(item.value)" :key="index">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn :key="index" :class="references.end_buttons.length - 1 === index ? 'mr-10' : ''" dark :loading="button.loading" :id="button.name" v-else-if="!button.ismenu && button.is_show" @click="button.click" :color="button.color" :disabled="button.disabled"> {{ button.label }} </v-btn>
          <v-spacer :key="`${index}_space`" v-if="button.space"></v-spacer>
        </template>
        <slot name="share_report"></slot>
        <slot name="download_report"></slot>
      </v-card-actions>
      <slot name="button" v-else></slot>
    </v-form>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    references: {
      type: Object
    },
    model: {
      type: Object
    }
  },
  computed: {
    ...mapState(['FORM_TYPE'])
  },
  methods: {
    allowedStep: m => m % 5 === 0,
    handlerEnterPress (event, index) {
      event.preventDefault()
      event.stopImmediatePropagation()
      let currentItem = this.references.properties[index]
      // eslint-disable-next-line
      var e = e || window.event // for IE to cover IEs window event-object
      if (e.shiftKey && e.which === 13) {
        let item = this.references.properties[index - 1]
        if (item && item.disabled) item = this.references.properties[index - 2]
        this.currentlyFocusedItem = item.disabled ? index - 2 : index - 1
        this.$refs[currentItem.ref][0].blur()
        setTimeout(() => {
          this.$refs[item.ref][0].focus()
        }, 100)
      } else {
        let item = this.references.properties[index + 1]
        if (item && item.disabled) item = this.references.properties[index + 2]
        if (item) {
          this.currentlyFocusedItem = item.disabled ? index + 2 : index + 1
          this.$refs[currentItem.ref][0].blur()
          setTimeout(() => {
            this.$refs[item.ref][0].focus()
          }, 100)
        } else {
          if (index + 1 === this.references.properties.length) {
            this.currentlyFocusedItem = null
            this.$refs[currentItem.ref][0].blur()
            this.$refs.saveupdate[0].$el.focus()
          }
        }
      }
    }
  }
}
</script>
